import { LogRepository } from '../Repositories/LogRepository';

export class DeleteLogUseCase {
  constructor(private repo: LogRepository) {}

  execute(logId: number): Promise<void> {
    return this.repo.deleteLog(logId);
  }

  executeBulk(logIds: number[]): Promise<void> {
    return this.repo.bulkDeleteLogs(logIds);
  }
} 